// extracted by mini-css-extract-plugin
var _1 = "U2cruWsM0lRtCdGIYezR";
export { _1 as "embeddedVideo" }
